let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cSKuM")).then(() => parcelRequire('226GG'));